import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Announcement = function Announcement(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? '#6F4EF6' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M19.7122 46C18.0997 46 16.5747 45.0125 15.9747 43.425L9.44971 27.375L11.2997 26.625L17.8372 42.6875C18.2372 43.7375 19.3997 44.2625 20.4247 43.8625L22.7122 42.9875C23.2122 42.8 23.6122 42.425 23.8247 41.9375C24.0497 41.45 24.0622 40.9125 23.8747 40.4125L18.4747 27.375L20.3247 26.6125L25.7372 39.675C26.1247 40.7 26.0997 41.7875 25.6622 42.7626C25.2247 43.7376 24.4372 44.4875 23.4372 44.8625L21.1497 45.7375C20.6622 45.9125 20.1872 46 19.7122 46Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M41 38.2374L24.125 27.9999H10.5C5.8125 27.9999 2 24.1874 2 19.4999C2 14.8124 5.8125 10.9999 10.5 10.9999H24.125L41 0.76239V38.2374ZM10.5 12.9999C6.9125 12.9999 4 15.9124 4 19.4999C4 23.0874 6.9125 25.9999 10.5 25.9999H24.6875L39 34.6874V4.31239L24.6875 12.9999H10.5Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M40 25.2127V23.2127C42.2 23.2127 44 21.3252 44 19.0002C44 16.6752 42.2 14.7877 40 14.7877V12.7877C43.3125 12.7877 46 15.5752 46 19.0002C46 22.4252 43.3125 25.2127 40 25.2127Z",
      fill: secondaryColor
    })]
  });
};
export default Announcement;